import React from 'react';
import { messageUtility } from '../../utilities/messageUtility';

export const RecoveryUnapproval = ({ onUnapprove, onClose }) => (
  <div
    className='dialog-md dialog--modal'
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-md__header'>
      <span className='dialog-md__title'>是正報告の承認解除</span>
    </div>
    <div className='dialog-md__body text-left'>
      <p>{messageUtility.getMessage('I-001-411')}</p>
    </div>
    <div className='dialog-md__footer-horizontal'>
      <button
        className='btn-fixedsize--sub'
        onClick={() => {
          onClose();
        }}
      >
        戻る
      </button>
      <button
        className='btn-fixedsize--negative'
        onClick={() => {
          onUnapprove();
          onClose();
        }}
      >
        承認解除
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/RecoveryUnapproval.jsx